// Pages that show a single venue's data but are not venue-scoped in the path.
// They carry the venue as ?venueId= so the nav bar's switcher can drive them
// without navigating the user off the page.
const VENUE_QUERY_ROUTES = ["/recurring-reservations", "/reports"];

export const usesVenueQueryParam = (pathname: string): boolean =>
  VENUE_QUERY_ROUTES.includes(pathname);

// Minimal shape shared by URLSearchParams and next/navigation's readonly one.
interface ReadableParams {
  get(name: string): string | null;
}

// The venue a URL is currently showing, wherever it happens to carry it.
//
// The path case reads the route params rather than the pathname: next-intl's
// usePathname() resolves against the `pathnames` config and hands back the
// matching key, so a registered route reads as the literal
// "/venues/[venueId]/subscription" with no id in it to parse.
export const venueIdFromUrl = (
  pathname: string,
  searchParams: ReadableParams,
  routeParams: Record<string, string | string[] | undefined>
): string | null => {
  if (usesVenueQueryParam(pathname)) return searchParams.get("venueId");
  const fromRoute = routeParams.venueId;
  return typeof fromRoute === "string" ? fromRoute : null;
};
